import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "winner-section" }
const _hoisted_3 = { class: "result-title" }
const _hoisted_4 = { class: "search-content" }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "field-grid" }
const _hoisted_10 = { class: "field-grid" }
const _hoisted_11 = {
  key: 0,
  class: "search-title",
  style: {"margin-top":"1.5rem"}
}
const _hoisted_12 = {
  key: 1,
  class: "loader"
}
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  disabled: "",
  rows: "5",
  cols: "33"
}
const _hoisted_17 = {
  disabled: "",
  rows: "5",
  cols: "33"
}
const _hoisted_18 = {
  disabled: "",
  rows: "5",
  cols: "33"
}
const _hoisted_19 = ["value"]
const _hoisted_20 = ["value"]
const _hoisted_21 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[18] || (_cache[18] = _createElementVNode("h1", { class: "search-title pl-2" }, "Select A Bonus Winner", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("select", {
              class: "dropdown",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCompetitionId) = $event))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("option", {
                disabled: "",
                value: null
              }, "Select a competition", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeCompetitions, (competition) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: competition.competitionId,
                  value: competition.competitionId
                }, _toDisplayString(competition.competitionTitle) + " (WSP" + _toDisplayString(competition.competitionId) + ") ", 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedCompetitionId]
            ]),
            _createElementVNode("button", {
              class: "select-winner-button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectBonusWinner && _ctx.selectBonusWinner(...args))),
              disabled: _ctx.isSubmitting
            }, [
              (!_ctx.isSubmitting)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Select Bonus Winner"))
                : _createCommentVNode("", true),
              (_ctx.isSubmitting)
                ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "search-title" }, "Prize", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("p", null, "Enter the bonus prize name. Letters and numbers only, no spaces or special characters.", -1)),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              id: "prize",
              type: "text",
              class: "text-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.prize) = $event)),
              placeholder: "e.g. BonusTV"
            }, null, 512), [
              [_vModelText, _ctx.prize]
            ])
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", {
            class: "search-title",
            style: {"margin-top":"1.5rem"}
          }, "Entry Cut-off Date & Time", -1)),
          _cache[17] || (_cache[17] = _createElementVNode("p", null, "Only entries submitted on or before this date and time will be included in the draw.", -1)),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              id: "cutoff",
              type: "datetime-local",
              class: "text-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cutOffDateTime) = $event))
            }, null, 512), [
              [_vModelText, _ctx.cutOffDateTime]
            ])
          ]),
          (_ctx.bonusWinnerDetailsList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Draw Results"))
            : _createCommentVNode("", true),
          (_ctx.loadingWinner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Running bonus draw..."))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.bonusWinnerDetailsList, (winner, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "info-grid",
                  key: index
                }, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Prize:")
                  ], -1)),
                  _createElementVNode("input", {
                    disabled: "",
                    value: winner.prize,
                    readonly: ""
                  }, null, 8, _hoisted_13),
                  _cache[6] || (_cache[6] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Competition Id:")
                  ], -1)),
                  _createElementVNode("input", {
                    disabled: "",
                    value: winner.competitionId,
                    readonly: ""
                  }, null, 8, _hoisted_14),
                  _cache[7] || (_cache[7] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Number of Tickets Entered:")
                  ], -1)),
                  _createElementVNode("input", {
                    disabled: "",
                    value: winner.numberOfTicketsEntered,
                    readonly: ""
                  }, null, 8, _hoisted_15),
                  _cache[8] || (_cache[8] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Hash:")
                  ], -1)),
                  _createElementVNode("textarea", _hoisted_16, _toDisplayString(winner.hash), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Kms Signature:")
                  ], -1)),
                  _createElementVNode("textarea", _hoisted_17, _toDisplayString(winner.kmsSignature), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Random.org Signature:")
                  ], -1)),
                  _createElementVNode("textarea", _hoisted_18, _toDisplayString(winner.randomOrgSignature), 1),
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Winning Ticket:")
                  ], -1)),
                  _createElementVNode("input", {
                    disabled: "",
                    value: winner.winningTicket,
                    readonly: ""
                  }, null, 8, _hoisted_19),
                  _cache[12] || (_cache[12] = _createElementVNode("label", null, [
                    _createElementVNode("strong", null, "Winning User Id:")
                  ], -1)),
                  _createElementVNode("input", {
                    disabled: "",
                    value: winner.userId,
                    readonly: ""
                  }, null, 8, _hoisted_20),
                  _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                  _createElementVNode("a", {
                    target: "_blank",
                    class: "goto-winner-button",
                    href: `/users/${winner.userId}`
                  }, " see winner details ", 8, _hoisted_21)
                ]))
              }), 128))
        ])
      ])
    ])
  ]))
}